// Central site data for LNZ Designs & Development Co. Ltd
export const BRAND = {
  name: "LNZ Designs & Development Co. Ltd",
  short: "LNZ",
  tagline: "Building Smart. Designing with Purpose.",
  logo: "https://customer-assets.emergentagent.com/job_7157ae0d-6d42-458a-b5d2-8f22b0a1e387/artifacts/wgqswldl_LNZ%20Front.png",
  phone: "876-521-9232",
  phoneDisplay: "876-521-9232",
  whatsapp: "18764081581",
  whatsappDisplay: "876-408-1581",
  email: "admin@thelnzgroup.com",
  address: "4½ Camp Road, Kingston, Jamaica",
  hours: "Mon – Fri · 8:30 AM – 5:30 PM (EST)",
  established: "2019",
  socials: {
    instagram: "https://instagram.com",
    linkedin: "https://linkedin.com",
    facebook: "https://facebook.com",
  },
};

export const HERO_SLIDES = [
  {
    url: "https://images.unsplash.com/photo-1769247178312-664ae1262cb6?auto=format&fit=crop&w=2200&q=85",
    label: "ACTIVE CONSTRUCTION SITE · NIGHT BUILD",
  },
  {
    url: "https://images.unsplash.com/photo-1764270594264-4af7654f7cb0?auto=format&fit=crop&w=2200&q=85",
    label: "MODERN COMMERCIAL DEVELOPMENT",
  },
  {
    url: "https://images.unsplash.com/photo-1759922378222-47ad736a174d?auto=format&fit=crop&w=2200&q=85",
    label: "ENGINEERING TEAM · ON-SITE REVIEW",
  },
  {
    url: "https://images.unsplash.com/photo-1706808849803-f61304e024ab?auto=format&fit=crop&w=2200&q=85",
    label: "ARCHITECTURAL RENDERING · LUXURY RESIDENCE",
  },
];

export const STATS = [
  { value: 40, suffix: "+", label: "Years Combined Industry Experience" },
  { value: 100, suffix: "+", label: "Projects Completed" },
  { value: 15, suffix: "", label: "Licensed Professionals" },
];

export const SERVICES = [
  {
    icon: "Compass",
    title: "Engineering",
    desc: "Civil, structural and MEP engineering built to withstand Caribbean conditions and exceed code.",
  },
  {
    icon: "Ruler",
    title: "Architectural Design",
    desc: "Concept-to-construction drawings that balance aesthetics, climate and investor value.",
  },
  {
    icon: "HardHat",
    title: "Construction",
    desc: "Full general contracting for residential, commercial and mixed-use developments island-wide.",
  },
  {
    icon: "ClipboardList",
    title: "Project Management",
    desc: "Transparent scheduling, cost control and stakeholder reporting through every phase.",
  },
  {
    icon: "Map",
    title: "Land Development",
    desc: "Site selection, subdivision planning and infrastructure readiness for greenfield projects.",
  },
  {
    icon: "Calculator",
    title: "Quantity Surveying",
    desc: "Precise BoQs, tender management and life-cycle cost forecasting for confident budgets.",
  },
  {
    icon: "Hammer",
    title: "Renovation & Remodeling",
    desc: "Premium refurbishments that modernize existing buildings without losing their character.",
  },
  {
    icon: "Building2",
    title: "Infrastructure",
    desc: "Roads, drainage, utilities and public works engineered for scale and long-term resilience.",
  },
];

// Real LNZ project portfolio
export const PROJECTS = [
  {
    title: "NHT Housing Development",
    category: "Housing",
    location: "Clarendon & Manchester, Jamaica",
    year: "2019 – 2023",
    scope: "Contract Administration",
    summary:
      "Contract administration services for the construction of multiple housing solutions across Clarendon and Manchester — overseeing scope, schedule and quality across an extended four-year delivery window.",
    image:
      "https://customer-assets.emergentagent.com/job_lnz-projects/artifacts/z7ll65px_house%20development%201.png",
  },
  {
    title: "PAHO Smart Hospital Project",
    category: "Healthcare",
    location: "Five Parishes, Jamaica",
    year: "2021 – 2023",
    scope: "Project Management",
    summary:
      "Project management for the renovation of five health centres — Hope, Manchester, Porus, Port Maria and Savanna-la-Mar — under the Pan American Health Organization's Smart Hospital initiative.",
    image:
      "https://customer-assets.emergentagent.com/job_lnz-projects/artifacts/nuvpihxb_Hospital.png",
  },
  {
    title: "Signal Hill Residences",
    category: "Residential",
    location: "Signal Hill, Tobago",
    year: "2022",
    scope: "Structural Design",
    summary:
      "Full structural design of a premium multi-family residential development — engineered for hillside topography, hurricane wind loads and long-term durability.",
    image:
      "https://customer-assets.emergentagent.com/job_lnz-projects/artifacts/h69dbsk6_signall%20hill.png",
  },
  {
    title: "Jamaica North–South Highway",
    category: "Infrastructure",
    location: "Jamaica North–South Corridor",
    year: "2021",
    scope: "Slope Inspection & Analysis",
    summary:
      "Slope inspection and stability analysis along the Jamaica North–South Highway — identifying geotechnical risk, recommending stabilization treatments and supporting safe long-term operation.",
    image:
      "https://customer-assets.emergentagent.com/job_lnz-projects/artifacts/7kfpgtvz_highway.png",
  },
];

export const PROJECT_CATEGORIES = [
  "All",
  "Housing",
  "Healthcare",
  "Residential",
  "Infrastructure",
];

export const WHY_CHOOSE = [
  { icon: "ShieldCheck", title: "Reliable Delivery", desc: "On-time handovers backed by disciplined project controls and contingency planning." },
  { icon: "Users", title: "Experienced Team", desc: "Engineers, architects and contractors averaging 15+ years of Caribbean project exposure." },
  { icon: "BadgeCheck", title: "Licensed & Certified", desc: "Registered with Jamaica's regulatory bodies and internationally recognized standards." },
  { icon: "PenTool", title: "Modern Design", desc: "Climate-smart architecture and BIM-driven engineering for future-ready buildings." },
  { icon: "LineChart", title: "Transparent Management", desc: "Real-time dashboards, milestone reporting and open-book cost tracking." },
  { icon: "Award", title: "Quality Standards", desc: "ISO-aligned quality assurance from foundation pour to punch-list sign-off." },
];

export const PROCESS_STEPS = [
  { num: "01", title: "Consultation", desc: "Understand your vision, budget and regulatory landscape." },
  { num: "02", title: "Site Evaluation", desc: "Topographic, geotechnical and feasibility assessments." },
  { num: "03", title: "Design & Planning", desc: "Architectural, structural and MEP design iterations." },
  { num: "04", title: "Approval & Budget", desc: "Permits, tendering and locked-in cost plans." },
  { num: "05", title: "Construction", desc: "Build-phase execution with weekly stakeholder reporting." },
  { num: "06", title: "Final Delivery", desc: "Commissioning, handover and post-occupancy support." },
];

export const INVESTOR_POINTS = [
  { title: "Local Expertise", desc: "Deep fluency with Jamaican regulators, parish councils and the NEPA approval process." },
  { title: "End-to-End Execution", desc: "One partner across land, design, build and commissioning — no coordination gaps." },
  { title: "Regulatory Guidance", desc: "Title verification, zoning, building permits and environmental compliance handled in-house." },
  { title: "Investment Strategy", desc: "Market intelligence on emerging parishes, yield zones and diaspora demand corridors." },
];

// Founder profile
export const FOUNDER = {
  name: "Dr Leighton A. Ellis",
  role: "Founder · Chartered Civil Engineer (CEng MICE)",
  photo:
    "https://customer-assets.emergentagent.com/job_lnz-projects/artifacts/4ldljts7_meet%20the%20founder%20headshot.jpeg",
  bio: [
    "Dr Leighton A. Ellis is a Chartered Civil Engineer (CEng MICE) with the Institution of Civil Engineers (ICE) and registered with the Engineering Council (ECUK), as well as a registered Civil Engineer and Construction Engineer in Trinidad & Tobago and Jamaica, respectively. He possesses over 20 years of experience in the construction industry and academia.",
    "His diverse professional experience in design and construction spans various sub-disciplines of civil engineering, namely construction, coastal/marine, structural, highway and environmental. In academia, he leads the development of future engineers through teaching and research. He also holds a BSc, MSc, and PhD in Construction Engineering, as well as a Diploma in Structural Engineering.",
    "He has served as Chairperson of the ICE West Indies Local Association, Vice President of Engineering Affairs for the Jamaica Institution of Engineers (JIE), and Vice President of the Caribbean Water and Wastewater Association (CWWA) — Jamaica Chapter. He currently serves as the Regional Chair of the Institution of Civil Engineers (ICE) Americas and the President-Elect of the JIE.",
  ],
  highlights: [
    { value: "20+", label: "Years in Practice" },
    { value: "BSc · MSc · PhD", label: "Construction Engineering" },
    { value: "JM · TT · UK", label: "Caribbean & UK Reach" },
  ],
};

export const CERTIFICATIONS = [
  { body: "Institution of Civil Engineers (ICE) UK", title: "Chartered Civil Engineer", id: "65944771" },
  { body: "Engineering Council, UK", title: "Chartered Engineer", id: "629055" },
  { body: "Board of Engineers of Trinidad & Tobago (BOETT)", title: "Registered Civil Engineer", id: "04-1381" },
  { body: "Professional Engineering Registration Board (PERB)", title: "Construction Engineer", id: "PE-16-01146" },
  { body: "Association of Professional Engineers of Trinidad & Tobago (APETT)", title: "Corporate Member", id: "130922" },
  { body: "Jamaica Institution of Engineers (JIE)", title: "Full Member", id: "148270" },
  { body: "Chartered Institute of Arbitrators (CIArb)", title: "Associate Member (Mediation)", id: "36626" },
  { body: "Mediation Board of Trinidad & Tobago", title: "Certified Mediator", id: "" },
];
